import { PaymentAccount } from "./payment-account.model";
import { PaymentCountry } from "./payment-country.model";

export class PaymentDetails {
    constructor() {
        this.accounts = [];
        this.countries = [];
    }

    accounts: Array<PaymentAccount>;
    countries: Array<PaymentCountry>;
}
